import { DateTime } from 'luxon';
import { MonthlyPassPermit, WeeklyPassPermit } from '../../generated/graphql';

export type PassItem =
  | { type: 'monthly'; pass: MonthlyPassPermit }
  | { type: 'weekly'; pass: WeeklyPassPermit };

export type PassListEntry =
  | { kind: 'header'; label: 'Active' | 'Inactive' }
  | { kind: 'pass'; item: PassItem };

export function partitionPasses(passes: PassItem[], now = DateTime.now()) {
  const active = passes
    .filter((p) => DateTime.fromSeconds(p.pass.untilTime) > now)
    .sort((a, b) => a.pass.untilTime - b.pass.untilTime);
  const inactive = passes
    .filter((p) => DateTime.fromSeconds(p.pass.untilTime) <= now)
    .sort((a, b) => b.pass.untilTime - a.pass.untilTime);
  return { active, inactive };
}

export function buildPassList(passes: PassItem[], now = DateTime.now()): PassListEntry[] {
  const { active, inactive } = partitionPasses(passes, now);
  return [
    ...(active.length ? [{ kind: 'header' as const, label: 'Active' as const }] : []),
    ...active.map((item) => ({ kind: 'pass' as const, item })),
    ...(inactive.length ? [{ kind: 'header' as const, label: 'Inactive' as const }] : []),
    ...inactive.map((item) => ({ kind: 'pass' as const, item })),
  ];
}
